/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_BalanceInputs */

const en_settings_credits_balance = /** @type {(inputs: Settings_Credits_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance`)
};

const zh_settings_credits_balance = /** @type {(inputs: Settings_Credits_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`余额`)
};

/**
* | output |
* | --- |
* | "Balance" |
*
* @param {Settings_Credits_BalanceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_balance = /** @type {((inputs?: Settings_Credits_BalanceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_BalanceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_balance(inputs)
	return zh_settings_credits_balance(inputs)
});
export { settings_credits_balance as "settings.credits.balance" }